import React from "react";
import DetailsRow from "./DetailsRow";

const DetailsSection = ({ rows, filters }) => {
  const { name, days, jobsComplete, totalWorkedTime } = rows

  const isVrDraftsman = filters.drafting_type === "vr"

  return (
    <>
      <div className="my-5">
        <h5>{name}</h5>
        <div className="table-responsive">
          <table className="table table-listing table-hover table-striped">
            <thead>
              <tr>
                <th>{`${isVrDraftsman ? "VR " : ""} Draftman Name`}</th>
                <th>Job No</th>
                <th>Job Title</th>
                <th>Job Service/Type</th>
                <th>Dept. Start Date</th>
                <th>Finish Date</th>
                <th>Time Spent</th>
              </tr>
            </thead>
            <tbody>
              <DetailsRow days={days} />
              { false && (
                <tr className="font-weight-bold text-white bg-dark" style={{ backgroundColor: "#343a40" }}>
                  <td>Total</td>
                  <td colSpan={4}></td>
                  <td>{`${jobsComplete} Jobs`}</td>
                  <td>{`${totalWorkedTime} Hrs`}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default DetailsSection
